import { render } from "./MButton.vue?vue&type=template&id=c9b3e356&scoped=true"
import script from "./MButton.vue?vue&type=script&lang=js"
export * from "./MButton.vue?vue&type=script&lang=js"

import "./MButton.vue?vue&type=style&index=0&id=c9b3e356&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b3e356"]])

export default __exports__